import { template as template_574d8e66805d4ec5b7d4a4b0a02e895f } from "@ember/template-compiler";
import { isBlank } from '@ember/utils';
import { fn } from '@ember/helper';
import BsTooltip from 'eflex/components/bs-tooltip';
import { t } from 'ember-intl';
import NumberControl from 'eflex/components/bs-form/element/control/number';
const updateOpacity = (onUpdate, opacity)=>{
    if (isBlank(opacity) || opacity < 0 || isNaN(opacity)) {
        opacity = 0;
    } else if (opacity > 100) {
        opacity = 100;
    }
    onUpdate(opacity);
};
export default template_574d8e66805d4ec5b7d4a4b0a02e895f(`
<NumberControl
  class="opacity-input"
  @value={{@opacity}}
  min={{0}}
  max={{100}}
  @disabled={{@disabled}}
  @onChange={{fn updateOpacity @update}}
  @units="%"
  ...attributes
>
  <BsTooltip @title={{t "imageEditor.opacity"}} @delayShow={{600}} />
</NumberControl>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
